
export const getTimeDelta = (dt: Date) => {
    const segments = [
        ['week', 1000 * 60 * 60 * 24 * 7], // weeks
        ['day', 1000 * 60 * 60 * 24], // days
        ['hour', 1000 * 60 * 60], // hours
        ['minute', 1000 * 60] // minutes;
    ];
    const delta = dt.valueOf() - new Date().valueOf();

      if(delta < 0) {
        return '';
    }

    var segment;
    var segValue;
    for (var i = 0; i < segments.length; i++) {
        segment = segments[i];
        segValue = Math.floor(delta / segment[1]);
        if (segValue >= 1) {
            break;
        }
    }
    return '' + segValue + ' ' + segment[0] + (segValue === 1 ? '' : 's');
};

export const zeroToTwelve = (value: number) => value === 0 ? 12 : value;

export const formatTime = (dt: Date) => (
    zeroToTwelve(dt.getHours() % 12).toString().padStart(2, '0')
    + ':' + dt.getMinutes().toString().padStart(2, '0')
    + ' ' + (dt.getHours() < 12 ? 'AM' : 'PM')
);

export const formatDateMMDDYYYY = (dt: Date) => (
    (dt.getMonth()+1).toString().padStart(2, '0') + '/'
    + dt.getDate().toString().padStart(2, '0') + '/'
    + dt.getFullYear().toString()
);

export const formatDate = (dt: Date) => (
    dt.toDateString()
);

export const formatDateTime = (dt: Date) => formatDate(dt) + ' at ' + formatTime(dt);
